module.exports = __webpack_public_path__ + "media/aboutPage/small-circle-379b17f4.png";